import { createFileRoute, useSearch } from '@tanstack/react-router';
import { AccountUsersLayout, useAuth, useGetViewer, UserRole } from '@amber-ui/core';

function AccountUsersRoute() {
  const { viewer } = useGetViewer();
  // Read acct from URL search params (source of truth)
  const { acct } = useSearch({ strict: false }) as { acct?: string };
  const { account_id: session_account_id } = useAuth();
  const effectiveAccountId = acct || session_account_id || '';

  if (!viewer) return null;

  return (
    <AccountUsersLayout
      account_id={effectiveAccountId}
      viewerAccountId={viewer.account_id}
      hasAdminAccess={viewer.user.role === UserRole.Admin}
    />
  );
}

export const Route = createFileRoute('/_auth/account/users')({
  component: AccountUsersRoute,
});
